import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addCurrency, deleteCurrency, getAllCurrency, updateCurrency } from '../../redux/rtk/features/masters/currencySlice';
import PageTitle from '../page-header/PageHeader';

const CurrencyMaster = () => {
  const { Title } = Typography;

  const [editingcurrency, setEditingcurrency] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.currency);

  useEffect(() => {
    dispatch(getAllCurrency());
  }, [dispatch]);


  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingcurrency) {
        // Update existing currency
        const result = await dispatch(
          updateCurrency({ id: editingcurrency.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllCurrency());
        } else {
          message.error('Error updating currency!');
        }
      } else {
        // Add new currency
        const result = await dispatch(addCurrency(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllCurrency());
        } else {
          message.error('Error adding currency!');
        }
      }
      setEditingcurrency(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update currency!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteCurrency(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllCurrency()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {
            setEditingcurrency(record);
            form.setFieldsValue(record);}}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this currency?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
      <Col span={8}>
      <Card title={editingcurrency ? 'Edit Currency' : 'Add Currency'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="category-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
        
          <Form.Item
            name="currency"
            label="Currency"
            rules={[{ required: true, message: 'Please enter a currency!' }]}
          >
            <Input placeholder="Enter currency" />
          </Form.Item>

          <Button type="primary" block htmlType="submit">
                {editingcurrency ? 'Update Currency' : 'Add Currency'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Currency List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CurrencyMaster;
